import { h } from 'preact';
import Button from '../Button';

const IconButton = ({ iconName, ...buttonProps }) => (
  <Button {...buttonProps}>
    <shore-icon name={iconName} />
  </Button>
);

export default IconButton;
